<template>
	<div class="dialog-response-footer">
		<slot />
	</div>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.dialog-response-footer
	{
		@include flex(null, null, var(--spacing-4xs));
		flex-direction:column;
	}
}
</style>
